<template>
  <div class="w-full border rounded-lg px-4 lg_px-8 py-12">
    <h1 class="text-center text-2xl font-semibold leading-none mb-12">Join Meeting</h1>
    <form class="space-y-6" @submit.prevent="onSubmit">
      <FormField v-slot="{ componentField }" name="meetingCode">
        <FormItem>
          <FormLabel class="font-medium text-sm">Meeting Code</FormLabel>
          <FormControl>
            <Input v-bind="componentField" ref="meetingCode" type="text" maxlength="5" placeholder="Enter 5 digit code" @input="onInput" />
          </FormControl>
          <FormMessage />
        </FormItem>
      </FormField>
      <Button type="submit" class="w-full">Join Meeting</Button>
    </form>
  </div>
</template>

<script setup lang="ts">
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import * as z from 'zod'

const emit = defineEmits(['submit'])

const formSchema = toTypedSchema(
  z.object({
    meetingCode: z.string().min(5, 'Meeting code must be 5 digits').max(5, 'Meeting code must be 5 digits'),
  }),
)
const { handleSubmit, setFieldValue } = useForm({ validationSchema: formSchema })

const onSubmit = handleSubmit(values => emit('submit', values.meetingCode))

const onInput = (event: Event) => {
  const input = event.target as HTMLInputElement
  setFieldValue('meetingCode', input.value.replace(/\D/g, ''))
}
</script>
